import client from '@/api/client';
import { gql } from '@apollo/client';
import wordFragments from '@/gql-fragments/word';

const getWordProperties = (
  words: {
    properties: [string];
    synonyms: [string];
  },
) => client.query({
  query: gql`
    query($wordTranslation: [String], $wordSynonym: [String]) {
      getWordProperties(wordTranslation: $wordTranslation) {
        ...Word,
      }
      getWordSynonyms(wordSynonym: $wordSynonym) {
        ...Synonym
      }
    }
    ${wordFragments.Word}
    ${wordFragments.Synonym}
  `,
  variables: {
    wordTranslation: words.properties,
    wordSynonym: words.synonyms,
  },
});

const getPhraseProperties = (
  words: {
    synonyms: [string];
  },
) => client.query({
  query: gql`
    query($wordPropertyId: [Int]) {
      getPhrases(wordPropertyId: $wordPropertyId) {
        ...Phrase,
      }
    }
    ${wordFragments.Phrase}
  `,
  variables: {
    wordPropertyId: words.synonyms.map((el) => parseInt(el, 10)),
  },
});

export {
  getWordProperties,
  getPhraseProperties,
};
